import React from "react";
import useBaseRequest from "../../api/BaseRequest";
import DocumentGateway from "../../api/gateways/DocumentGateway";
import { TableRow } from "../../components/table";
import moment from "moment";
import { GetDocumentsDTO } from "../../entities/IDocument";
import { Icon } from "../../modules/icon";
import { useUser } from "../../store/auth/AuthSelectors";
import { QueryFilter } from "../../components/filters";
import { documentTableHeaders } from "./Documents.types";
import { useNavigate } from "react-router";
import { screens } from "../Navigation.types";
import { useDocumentService } from "../../services/useDocumentService";

export function useDocuments() {
  // states
  const user = useUser();
  const navigate = useNavigate();
  const { getDocFileUrl } = useDocumentService();

  /* React.useEffect(() => {
    function paramsToObject(entries: any) {
      const result: any = {};
      for (const [key, value] of entries) {
        // each 'entry' is a [key, value] tupple
        result[key] = value;
      }
      return result;
    }
    const entries = searchParams.entries();
    const params = paramsToObject(entries);
    console.log(params);
  }, []); */

  const defaultFilters: QueryFilter[] = [
    {
      name: "dealerCode",
      operator: "eq",
      value: user?.dealerCode,
      type: "string",
    },
  ];
  const [docTableData, setDocTableData] = React.useState<TableRow[]>([]);
  const [docPayload, setDocPayload] = React.useState<GetDocumentsDTO>({
    skip: 0,
    limit: 10,
    filters: defaultFilters,
    sort: {
      key: "createdAt",
      value: "DESC",
    },
  });
  const [selectedDocuments, setSelectedDocuments] = React.useState<number[]>(
    []
  );
  const [showBoxModal, setShowBoxModal] = React.useState(false);

  // requests
  const { data, execute, loading } = useBaseRequest(
    DocumentGateway.getDocuments,
    {
      autoFetch: true,
      initialPayload: docPayload,
      onCompleted: (data) => {
        const { documents } = data;
        const docTable: TableRow[] = [];
        documents.forEach((doc) => {
          docTable.push([
            doc.id,
            doc.metaData?.jmbg || doc.metaData?.mb || "",
            doc.metaData?.msisdn || "",
            doc.metaData?.signDate
              ? moment(doc.metaData?.signDate).format("DD.MM.YYYY")
              : "",
            doc.docType.title,
            doc.metaData?.archiveType || "",
            doc?.metaData?.boxId || "",
            moment(doc?.createdAt).format("DD.MM.YYYY"),
            doc.createdBy?.name || "",
            <div>
              <a
                target="_blank"
                rel="noreferrer"
                className="mr-3"
                href={
                  doc.files && doc.files.length
                    ? getDocFileUrl(doc.files[doc.files.length - 1].url)
                    : "/"
                }
              >
                <Icon type="fa-solid fa-file" color="black" size={16} />
              </a>
              <a href={`/documents/${doc.id}`}>
                <Icon type="fa-solid fa-circle-info" color="black" size={16} />
              </a>
            </div>,
          ]);
        });
        setDocTableData(docTable);
      },
    }
  );

  const { execute: updateDocs, loading: updating } = useBaseRequest(
    DocumentGateway.updateDocuments,
    {
      onCompleted: (data) => {
        execute(docPayload);
        setShowBoxModal(false);
        setSelectedDocuments([]);
      },
    }
  );

  // handlers
  const onSearchSubmit = (text: string) => {
    const newPayload = { ...docPayload, textSearch: text };
    setDocPayload(newPayload);
    execute(newPayload);
  };

  const onDocumentPerPageChange = (docNum: number) => {
    const newPayload = { ...docPayload, limit: docNum };
    setDocPayload(newPayload);
    execute(newPayload);
  };

  const onPageChange = (page: number) => {
    const newPayload = {
      ...docPayload,
      skip: page > 0 ? (page - 1) * (docPayload.limit || 10) : 10,
    };
    setDocPayload(newPayload);
    execute(newPayload);
  };

  const onAddBoxId = (boxId: string) => {
    updateDocs({ documentIds: selectedDocuments, metaData: { boxId } });
  };

  const onFilterChange = (queryFilters: QueryFilter[]) => {
    const newPayload = {
      ...docPayload,
      filters: queryFilters.concat(defaultFilters),
    };
    // setSearchParams(JSON.stringify(newPayload));
    setDocPayload(newPayload);
    execute(newPayload);
  };

  const onSort = (key: string, order: "ASC" | "DESC") => {
    const newPayload = {
      ...docPayload,
      sort: { key, value: order },
    };
    setDocPayload(newPayload);
    execute(newPayload);
  };

  const onRowPress = (id: number) => {
    navigate(screens.documents + `/${id}`);
  };

  return {
    docTableData,
    count: data?.count || 0,
    getDocuments: execute,
    loading,
    onSearchSubmit,
    user,
    onDocumentPerPageChange,
    selectedDocuments,
    setSelectedDocuments,
    onPageChange,
    showBoxModal,
    openBoxModal: () => setShowBoxModal(true),
    closeBoxModal: () => setShowBoxModal(false),
    onAddBoxId,
    updating,
    documentTableHeaders,
    onFilterChange,
    onSort,
    onRowPress,
  };
}
